__turbopack_context__.v({
  "heroBanner": "support-hero-banner-module-scss-module__J7K9QW__heroBanner",
  "heroBanner--DeepBlue": "support-hero-banner-module-scss-module__J7K9QW__heroBanner--DeepBlue",
  "heroBanner--equalWidth": "support-hero-banner-module-scss-module__J7K9QW__heroBanner--equalWidth",
  "heroBanner--imagePosition": "support-hero-banner-module-scss-module__J7K9QW__heroBanner--imagePosition",
  "imageContent": "support-hero-banner-module-scss-module__J7K9QW__imageContent",
  "textContent": "support-hero-banner-module-scss-module__J7K9QW__textContent",
  "textContent--design-2": "support-hero-banner-module-scss-module__J7K9QW__textContent--design-2",
});
